import { DEFAULT_CURRENCY_CODE } from '@constants/common';
import { SettlementMode } from '@constants/generic';

export const branchInitialState = {
  bank_account_name: '',
  bank_account_number: '',
  bank_branch_name: '',
  bank_ifsc: '',
  bank_name: '',
  is_active: false,
  isPrimary: false
};

export type NewBankType = {
  bank_account_number: string;
  bank_account_name: string;
  bank_ifsc: string;
  bank_logo: string;
  accountDetailId: string;
  bank_name?: string;
  nick_name?: string;
  status?: string;
};

export type BranchByIdType = {
  branch_id: string;
  name: string;
  amount_collected?: string;
  amount_due?: string;
  image_url?: string;
  fee_categories?: {
    id: number;
    category: string;
    account_detail_id: number;
  }[];
  is_fee_configured: boolean;
  activate_gst_feature?: boolean;
  address_line_1?: string;
  address_line_2?: string;
  city?: string;
  state?: string;
  country?: string;
  pincode?: string;
  sgst?: string;
  cgst?: string;
  igst?: string;
  gstin?: string;
  hsn_code?: string;
  is_inclusive_gst?: boolean;
  gst_type?: string;
  is_intro_msg_shared?: boolean;
  currency?: CurrencyType;
  branch_config?: {
    fine_config: {
      fine_starts_in_days: number;
      fine_type: string;
      fine_amount: number;
    };
    limits_config: {
      split_payment_limits: {
        required_amount_min: string;
        per_split_amount_min: string;
        per_split_amount_percentage_min: string;
        per_split_amount_automatic_min: string;
      };
    };
  };
  default_term_label?: string;
};

export type CurrencyType = {
  code?: string;
  locale?: string;
  symbol?: string;
};

export const BranchByIdInitialState = {
  branch_id: '',
  name: '',
  amount_collected: '',
  amount_due: '',
  image_url: '',
  fee_categories: [],
  is_fee_configured: false,
  is_intro_msg_shared: false
};

export const BANK_ACCOUNT_TABLE_LIMIT = 5;

export const defaultBranchDetails = {
  branchName: '',
  branchImage: {
    preview: ''
  },
  settlementMode: SettlementMode.BANK, // as upi is removed
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  country: '',
  pincode: '',
  currency: DEFAULT_CURRENCY_CODE
};

export type BankDetailsByIdType = {
  organisation_bank_account_detail: OrganisationBankAccountDetailType;
  remarks?: string;
  rejected_reason?: string;
  upload_bank_document_response: UploadBankDocumentResponseType;
};

export type OrganisationBankAccountDetailType = {
  id: string;
  bank_account_number: string;
  bank_account_name: string;
  bank_ifsc: string;
  bank_name: string;
  bank_branch_name: string;
  bank_logo: string;
  status: string;
  nick_name: string;
  merchant_reference_id: string;
  bank_ledger_name: string;
  pan: string;
};

export type UploadBankDocumentResponseType = {
  files: FileDetailType[];
  account_detail_id: string;
};

export type FileDetailType = {
  file_path: string;
  type: FileType;
};

export enum FileType {
  PAN = 'PAN',
  SUPPORTING_DOCUMENT = 'SUPPORTING_DOCUMENT'
}
